import { LitElement, html, css } from "lit-element";

export class SyncuiButton extends LitElement {
    constructor() {
        super();
        this.name = this.buttonName
    }


    static get styles() {
        return css`
        .btn {
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border: 1px solid transparent;
            padding: 6px 12px;
            font-size: 14;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn:hover, .btn:focus {
            text-decoration: none;
        }
          
        .btn:focus, .btn.focus {
            outline: 0;
            box-shadow: none;
        }
          
        .btn.disabled, .btn:disabled {
            opacity: 0.65;
        }
        
        .btn-success {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-success:hover {
            color: var(--w-btn-col, #505050);
            background-color: var(--w-btn-bgc, #fff);
            border: 1px solid var(--w-btn-borc, #505050);
            font-size: var(--w-btn-fs, 14px);
            cursor: pointer;
        }
        
        .btn-lg {
            padding: 8px 16;
            font-size: 14px;
            line-height: 1.5;
            border-radius: 4px;
        }
        
        .btn-block {
            display: block;
            width: 100%;
        }`;
    }

    render() {
        return html`
        <button class="btn btn-success btn-lg btn-block" @click=${this.onClick}><slot></slot></button>
        `;
    }

    onClick() {
        this.dispatchEvent(new CustomEvent('onButtonClick', {
            bubbles: true,
            composed: true,
            detail: {
            }
        }));
    }

}

customElements.define('syncui-button', SyncuiButton);